import { useQuery } from '@tanstack/react-query';
import { catalogApi } from '../api/catalogApi';
import type { CatalogData } from '../types/catalog';

export function useCatalog() {
  return useQuery<CatalogData>({
    queryKey: ['catalog'],
    queryFn: () => catalogApi.getCatalog(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
